module.exports = __webpack_public_path__ + "static/kw51_img_1-8621225e88890e7965dc0a14b8acc778.png";